import {REDUX_CONST} from '../../config/constats';

let emptyRecord = {
    id: null,
    espece_id: "",
    localisation: {
        type: '',
        coordinates: null
    },
    delimitations: {
        type: '',
        coordinates: null
    },
    delimitation_text: "",
    accessibilite: "",
    polygon: {},
    centroid: {}
};
const initialState = {
    dialogTitle: "",
    loading: false,
    loadingValidationProcess: true,
    editionMode: false,
    selectedRecord: {...emptyRecord},
    comboList:[],
    showErrorMessage: {
        show: false,
        message: ''
    },
};

export default (state = initialState, action) => {
    let dt = {};
    switch (action.type) {
        case REDUX_CONST.ESPECE.LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case REDUX_CONST.ESPECE.LOADING_VALIDATION_PROCESS:
            return {
                ...state,
                loadingValidationProcess: action.payload
            };
        case REDUX_CONST.ESPECE.FULL_LIST:
            return {
                ...state,
                dataList: action.payload,
                selectedRecord: {...emptyRecord},
            };
        case REDUX_CONST.ESPECE.COMBO:
            return {
                ...state,
                comboList: action.payload,
            };
        case REDUX_CONST.ESPECE.SET_SELECTED:
            return {
                ...state,
                selectedRecord: action.payload,
                editionMode: false,
            };
        case REDUX_CONST.ESPECE.ADD_NEW:
            return {
                ...state,
                dialogTitle: 'Nouvelle espece',
                editionMode: action.payload,
                selectedRecord: {...emptyRecord},
                loadingValidationProcess: false
            };
        case REDUX_CONST.ESPECE.EDIT_SELECTED:
            return {
                ...state,
                dialogTitle: `Edition espece`,
                editionMode: true,
                loadingValidationProcess: false,
                selectedRecord: action.payload,
            };
        case REDUX_CONST.ESPECE.CANCEL_EDIT:
            return {
                ...state,
                editionMode: false,
                loadingValidationProcess: false
            };
        case REDUX_CONST.ESPECE.DATA_SAVED:
            let {operation, data} = action.payload;
            return {
                ...state,
                selectedRecord: data,
                editionMode: false,
                loadingValidationProcess: false
            };
        default:
            return state;
    }
}
